import { useFrame } from '@studio-freight/hamo'
import cn from 'clsx'
import { CustomHead } from 'components/custom-head'
import Footer from 'components/MainFooter'
import { Intro } from 'components/intro'
import { Scrollbar } from 'components/scrollbar'
import { useStore } from 'lib/store'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import Lenis from '../../lenis.js'
import s from './layout.module.scss'
import styles from '../../components/MainFooter/footer.module.scss'
import {
  Menu,
  MenuItem,
  ProductItem,
  HoveredLink,
} from '../../components/navbar'

const Cursor = dynamic(
  () => import('components/cursor').then((mod) => mod.Cursor),
  { ssr: false }
)

const PageTransition = dynamic(
  () => import('components/page-transition').then((mod) => mod.PageTransition),
  { ssr: false }
)

export function Layout({
  seo = {
    title:
      "The Game Super Park | India's Premier Trampoline and Adventure Park.",
    description:
      "Explore The Game Super Park, recognized among India's top adventure parks having Arcade, Go-karting, Snow and Trampoline park. Plan your visit for the best experience. Book your slots now.",
    image: '',
    keywords:
      'Adventure park, adventure park in India, trampoline park, indoor playground for children, trampoline and adventure park, trampoline and adventure park in India, go-karting, game arcade, snow park.',
  },
  children,
  theme = 'light',
  className,
}) {
  const [lenis, setLenis] = useStore((state) => [state.lenis, state.setLenis])
  const router = useRouter()
  const [active, setActive] = useState(null)

  useEffect(() => {
    window.scrollTo(0, 0)
    const lenis = new Lenis({
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 1, // Increase for smoother touch scrolling
      wheelMultiplier: 1,
      syncTouch: false, // Try setting to false
      syncTouchLerp: 0.1, // Add smooth lerping for touch sync
    });
    window.lenis = lenis
    setLenis(lenis)

    // new ScrollSnap(lenis, { type: 'proximity' })

    return () => {
      lenis.destroy()
      setLenis(null)
    }
  }, [])

  const [hash, setHash] = useState()

  useEffect(() => {
    if (lenis && hash) {
      // scroll to on hash change
      const target = document.querySelector(hash)
      lenis.scrollTo(target, { offset: 0 })
    }
  }, [lenis, hash])

  useEffect(() => {
    // update scroll position on page refresh based on hash
    if (router.asPath.includes('#')) {
      const hash = router.asPath.split('#').pop()
      setHash('#' + hash)
    }
  }, [router])

  useEffect(() => {
    // catch anchor links clicks
    function onClick(e) {
      e.preventDefault()
      const node = e.currentTarget
      const hash = node.href.split('#').pop()
      setHash('#' + hash)
      setTimeout(() => {
        window.location.hash = hash
      }, 0)
    }

    const internalLinks = [...document.querySelectorAll('[href]')].filter(
      (node) => node.href.includes(router.pathname + '#')
    )

    internalLinks.forEach((node) => {
      node.addEventListener('click', onClick, false)
    })

    return () => {
      internalLinks.forEach((node) => {
        node.removeEventListener('click', onClick, false)
      })
    }
  }, [])

  useFrame((time) => {
    lenis?.raf(time)
  }, [])

  return (
    <>
      <CustomHead {...seo} />
      <div className={cn(`theme-${theme}`, s.layout, className)}>
        <div style={{ position: 'sticky', top: 0, zIndex: 50 }}>
          <Menu setActive={setActive} theme="light">
            <MenuItem
              setActive={setActive}
              active={active}
              href="/home"
              item="Home"
            ></MenuItem>
            <MenuItem
              setActive={setActive}
              active={active}
              href="/token"
              item="Token"
            ></MenuItem>
            <MenuItem
              setActive={setActive}
              active={active}
              href="/ecosystem"
              item="Ecosystem"
            ></MenuItem>
            <MenuItem
              setActive={setActive}
              active={active}
              href="/roadmap"
              item="Roadmap"
            ></MenuItem>
            <MenuItem
              setActive={setActive}
              active={active}
              href="/team"
              item="Team"
            ></MenuItem>
              <a
                href="#"
                target="_blank"
              >
                <img
                  src="/social-media-icons/png-twitter.png"
                  alt="Twitter"
                  width={30}
                  height={30}
                />
              </a>
              <a
                href="#"
                target="_blank"
              >
                <img
                  src="/social-media-icons/png-telegram.png"
                  alt="Twitter"
                  width={30}
                  height={30}
                />
              </a>
              <a
                href="#"
                target="_blank"
              >
                <img
                  src="/social-media-icons/png-linktree.png"
                  alt="Twitter"
                  width={30}
                  height={30}
                />
              </a>
            
            {/* <MenuItem
              setActive={setActive}
              active={active}
              href="https://linktr.ee/"
              item="Linktree"
            ></MenuItem>
            <MenuItem
              setActive={setActive}
              active={active}
              href="/contact"
              item="Contact"
            ></MenuItem> */}
          </Menu>
        </div>
        <PageTransition />
        <Intro />
        <Cursor />
        <Scrollbar />
        <main className={s.main}>{children}</main>
        <Footer />
      </div>
    </>
  )
}
